module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAMAAAAs2N9uAAAAV1BMVEUAAAAwcL84cL81db83b785dcI4dMM0cr42csM3dMI2c8I4csI3c8E4dME4dME3dME3c8E4c8A4c8E3c8A3dME4dMA4dME3dMA3c8A4c8A4c8A3c8A4dMF2tKjuAAAAHHRSTlMAECAwPD9ASkxPUGBvf4CPkJ+gr7C/wM/Q3+DvXd7AvQAAAIlJREFUGFdtjEECgjAQA0O1qxZ3AZEtlPz/nR5alINzmswhQCVkbXaQSv9awil0k9/ykEr6lku2fifzdR06AHCy3GeS5N6PJBMg8bGxMcUYAByzYQC42kiz8jYvZjUZQMAF5nWBiypVt0mXTbWmP19cvbC4V6lJYLSTgHzGuaYm7ctOAhERkfCTD9ZDEE49Q+1YAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/res/School_Game_Icon.png
// module id = 1129
// module chunks = 0